(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMhCarousels(root) {
      var carousels = (root || document).querySelectorAll('[data-mh-carousel]');
      carousels.forEach(function (carousel) {
        if (carousel.dataset.mhInit) return;
        carousel.dataset.mhInit = 'true';

        var track = carousel.querySelector('[data-mh-track]');
        var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-mh-slide]'));
        var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-mh-dot]'));
        var prevBtn = carousel.querySelector('[data-mh-prev]');
        var nextBtn = carousel.querySelector('[data-mh-next]');
        var section = carousel.closest('.mh-hero');
        var autoplay = section && section.dataset.autoplay === 'true';
        var autoplaySpeed = (section && parseFloat(section.dataset.autoplaySpeed)) || 5;
        var index = 0;
        var timer = null;

        function goTo(i, behavior) {
          index = (i + slides.length) % slides.length;
          track.scrollTo({ left: track.clientWidth * index, behavior: behavior || 'smooth' });
          dots.forEach(function (dot, di) {
            var active = di === index;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-selected', active ? 'true' : 'false');
          });
        }

        function next() { goTo(index + 1); }
        function prev() { goTo(index - 1); }

        if (nextBtn) nextBtn.addEventListener('click', function () { next(); restartAutoplay(); });
        if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restartAutoplay(); });

        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            goTo(parseInt(dot.dataset.index, 10));
            restartAutoplay();
          });
        });

        var scrollTimeout;
        track.addEventListener('scroll', function () {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(function () {
            var newIndex = Math.round(track.scrollLeft / track.clientWidth);
            if (newIndex !== index) {
              index = newIndex;
              dots.forEach(function (dot, di) {
                var active = di === index;
                dot.classList.toggle('is-active', active);
                dot.setAttribute('aria-selected', active ? 'true' : 'false');
              });
            }
          }, 80);
        }, { passive: true });

        function startAutoplay() {
          if (!autoplay || slides.length < 2) return;
          timer = setInterval(next, autoplaySpeed * 1000);
        }
        function stopAutoplay() {
          if (timer) clearInterval(timer);
        }
        function restartAutoplay() {
          stopAutoplay();
          startAutoplay();
        }

        carousel.addEventListener('touchstart', stopAutoplay, { passive: true });
        carousel.addEventListener('touchend', startAutoplay, { passive: true });

        window.addEventListener('resize', function () {
          goTo(index, 'auto');
        });

        startAutoplay();
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      initMhCarousels(document);
    });

    document.addEventListener('shopify:section:load', function (e) {
      initMhCarousels(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProductGrid(root) {
      var sections = (root || document).querySelectorAll('.pg');
      sections.forEach(function (section) {
        if (section.dataset.pgInit) return;
        section.dataset.pgInit = 'true';

        var grid = section.querySelector('[data-pg-grid]');
        var cards = Array.prototype.slice.call(section.querySelectorAll('[data-pg-card]'));
        var emptyMsg = section.querySelector('[data-pg-empty]');
        var countEl = section.querySelector('[data-pg-count]');

        var catSel = section.querySelector('[data-pg-category]');
        var priceSel = section.querySelector('[data-pg-price]');
        var sortSel = section.querySelector('[data-pg-sort]');
        var catSelM = section.querySelector('[data-pg-category-mobile]');
        var priceSelM = section.querySelector('[data-pg-price-mobile]');
        var sortSelM = section.querySelector('[data-pg-sort-mobile]');

        var sheet = section.querySelector('[data-pg-sheet]');
        var openBtn = section.querySelector('[data-pg-filter-open]');
        var closeEls = section.querySelectorAll('[data-pg-sheet-close]');

        function syncPair(a, b) {
          if (!a || !b) return;
          a.addEventListener('change', function () { b.value = a.value; apply(); });
          b.addEventListener('change', function () { a.value = b.value; apply(); });
        }
        syncPair(catSel, catSelM);
        syncPair(priceSel, priceSelM);
        syncPair(sortSel, sortSelM);

        if (openBtn && sheet) {
          openBtn.addEventListener('click', function () { sheet.hidden = false; });
        }
        closeEls.forEach(function (el) {
          el.addEventListener('click', function () { sheet.hidden = true; });
        });

        function apply() {
          var cat = (catSel && catSel.value) || 'all';
          var priceRange = (priceSel && priceSel.value) || 'all';
          var sortBy = (sortSel && sortSel.value) || 'featured';

          var visibleCount = 0;
          cards.forEach(function (card) {
            var matchesCat = cat === 'all' || card.dataset.category === cat;
            var matchesPrice = true;
            if (priceRange !== 'all') {
              var bounds = priceRange.split('-').map(Number);
              var price = parseFloat(card.dataset.price) || 0;
              matchesPrice = price >= bounds[0] && price <= bounds[1];
            }
            var visible = matchesCat && matchesPrice;
            if (visible) {
              card.removeAttribute('data-hidden');
              visibleCount++;
            } else {
              card.setAttribute('data-hidden', 'true');
            }
          });

          if (countEl) countEl.textContent = visibleCount + (visibleCount === 1 ? ' Product' : ' Products');
          if (emptyMsg) emptyMsg.hidden = visibleCount !== 0;

          // Sort only the compact grid; featured row stays curated/fixed.
          if (grid) {
            var gridCards = Array.prototype.slice.call(grid.querySelectorAll('[data-pg-card]'));
            var sorted = gridCards.slice().sort(function (a, b) {
              if (sortBy === 'price-asc') return (parseFloat(a.dataset.price) || 0) - (parseFloat(b.dataset.price) || 0);
              if (sortBy === 'price-desc') return (parseFloat(b.dataset.price) || 0) - (parseFloat(a.dataset.price) || 0);
              return 0; // featured = original block order
            });
            sorted.forEach(function (card) { grid.appendChild(card); });
          }
        }

        [catSel, priceSel, sortSel].forEach(function (el) {
          if (el) el.addEventListener('change', apply);
        });

        apply();
      });
    }

    document.addEventListener('DOMContentLoaded', function () { initProductGrid(document); });
    document.addEventListener('shopify:section:load', function (e) { initProductGrid(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
